export default __webpack_public_path__ + "static/media/pricing-page-background.6c9c9a87.png";